<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/material/bom/item/page" getKey="rows"
			:columns="columns">
			<template #top>
				<div class="check">
					<el-descriptions :colon="false">
						<el-descriptions-item :label="$t('wuliaoBOMmingcheng')">
							{{ $attrs.check.name }}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</template>
			<!-- 配方重量 -->
			<template #peifangyongliaoliang="scope">
				<template>
					{{ (scope.row.weight).toFixed(3) }}
				</template>
			</template>
		</yi_curd_table>
	</div>
</template>

<script type="text/javascript">
export default {
	name: 'web_base_matter_check_bom',
	data() {
		return {
			readonly: true,
			columns: [{
				label: 'wuliaobianma',
				prop: 'materialCode',
			}, {
				label: 'wuliaomingcheng',
				prop: 'materialName',
				width: 180
			}, {
				label: 'peifangbili',
				prop: 'ratio',
				isStar: true
			}, {
				label: 'peifangyongliaoliang',
				prop: 'weight',
				type: 'slot'
			}, {
        label: 'morendanwei',
        prop: 'defaultUnit',
        type: 'dictionary',
        key: 'UNIT_CONVERSION_TYPE'
      }]
		}
	},
	created() {
		setTimeout(() => {
			this.yt.conditions = {
				bomId: this.$attrs.check.id,
				pageNum: 1,
				pageSize: 100
			}
			this.yt.get(1);
			this.yt.isShowPagination = false;
		}, 300)

	},
	methods: {
		beforeAdd(params, url) {
			params.bomId = this.$attrs.check.id
			return params
		},
	}
}
</script>

<style scoped lang="scss"></style>
